import { useMediaQuery } from 'react-responsive';
import { ICustomType } from './interfaces/GlobalInterfaces';

const IMAGE_URL: string | undefined = process.env.REACT_APP_IMAGE_SERVER_URL; // change url

export const setImageSize = (imgUrl: string, width: number | string, height: number | string, articleId: number) => {
  if (articleId !== 0) {
    return `${IMAGE_URL}returnimage/?url=${encodeURIComponent(imgUrl)}&width=${width}&height=${height}&articleid=${articleId}`;
  }
  return imgUrl;
};
export default setImageSize;

//   export const backgroundColorParsing = (personality: PersonalityTypes[]) => {
export const backgroundColorParsing = (personality: any) => {
  if (personality.length < 1) return '#979797 50%, #979797 50% ';
  if (personality.length > 1) return `${personality[0].color} 50%, ${personality[1].color} 100%`;
  return `${personality[0].color} 50%, ${personality[0].color} 100%`;
};

export const colorParsing = (personality: any) => `${personality.color} 50%, ${personality.color} 100%`;
//   export const colorParsing = (personality: ArcheType) => `${personality.color} 50%, ${personality.color} 100%`;

export const MaxWidthApp = () => {
  const isResolution = useMediaQuery({
    query: '(max-width: 1500px)',
  });
  return isResolution;
};

export const getPersonalitiesFromPersona = (persona: string) => {
  return persona === 'Dominant'
    ? ['Designer', 'Leader', 'Driver', 'Creator']
    : persona === 'Influencer'
    ? ['Persuader', 'Motivator', 'Promoter', 'Collaborator']
    : persona === 'Steady'
    ? ['Advocate', 'Proponent', 'Coordinator', 'Equalizer']
    : persona === 'Conscientious'
    ? ['Manager', 'Strategist', 'Challenger', 'Investigator']
    : ['N/A'];
};

export const MinWidthApp = () => {
  const isResolution = useMediaQuery({
    query: '(max-width: 1100px)',
  });
  return isResolution;
};

export const IsTablet = () => {
  const isResolution = useMediaQuery({
    query: '(max-width: 1023px)',
  });
  return isResolution;
};

export const IsMobile = () => {
  const isResolution = useMediaQuery({
    query: '(max-width: 768px)',
  });
  return isResolution;
};

export const IsWidth1300 = () => {
  const isResolution = useMediaQuery({
    query: '(max-width: 1300px)',
  });
  const endResolution = useMediaQuery({
    query: '(min-width: 1023px)',
  });
  if (isResolution && endResolution) {
    return true;
  }
  return false;
};

export const scrollWithId = (element: HTMLElement | null, extra = 0) => {
  if (element) {
    const yOffset = -120;
    const yScroll = element.getBoundingClientRect().top + window.pageYOffset + yOffset - extra;
    window.scrollTo({ top: yScroll, behavior: 'smooth' });
  }
};

export const smoothBehavior = () => {
  const id = 'tabs-details';
  const element: HTMLElement | null = document.getElementById(id);
  scrollWithId(element);
};

export const scrollHandlerToggleClass = (element: string, className: string, depend?: boolean) => {
  const header: HTMLElement | null = document.querySelector(element);
  const sticky: number | null = header && header.offsetTop;
  window.addEventListener('scroll', () => {
    if (depend && sticky !== null) {
      if (window.pageYOffset > sticky) {
        return header && header.classList.add(className);
      }
    }
    if (window.pageYOffset > 80) {
      return header && header.classList.add(className);
    }
    return header && header.classList.remove(className);
  });
};

export const objectToFormDataArray = (obj: { [key: string | number]: ICustomType }) => {
  const formData = new FormData();

  if (!obj) return formData;

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item: ICustomType) => {
        if (item !== undefined && item !== null && (typeof item === 'string' ? (item !== '' ? true : false) : true))
          formData.append(key, item.toString());
      });
    } else {
      if (value !== undefined && value !== null && (typeof value === 'string' ? (value !== '' ? true : false) : true))
        formData.append(key, value.toString());
    }
  });

  return formData;
};
